import ImageWithFallback from "@/components/ImageWithFallback";
import StatusBadge from "@/components/StatusBadge";

export const columns = () => {
  return [
    {
      accessorKey: "status",
      header: "Status",
      cell: ({ row }) => <StatusBadge status={row.getValue("status")} />,
    },
    {
      accessorKey: "hierarchy",
      header: "Hierarchy",
      size: 60,
      cell: ({ row }) => (
        <div className={"flex justify-center"}>
          {row.original.level}.{row.original.order}
        </div>
      ),
    },
    {
      accessorKey: "sport.code",
      header: "Sport ID",
    },
    {
      accessorKey: "competition_group.code",
      header: "Competition Group",
      cell: ({ row }) => <div>{row.original.competition_group?.code}</div>,
    },
    {
      accessorKey: "code",
      header: "ID",
      cell: ({ row }) => <div>{row.getValue("code")}</div>,
    },
    {
      accessorKey: "icon_url",
      header: "Icon",
      cell: ({ row }) => <ImageWithFallback url={row.getValue("icon_url")} />,
      enableResizing: false,
      enableSorting: false,
    },
    {
      accessorKey: "total_likes",
      header: "Likes",
      cell: ({ row }) => <div>{row.original.likes?.total_likes || 0}</div>,
    },
    {
      accessorKey: "total_share",
      header: "Shares",
      cell: ({ row }) => <div>{row.original.shares?.total_shares || 0}</div>,
    },
    {
      accessorKey: "total_views",
      header: "Views",
      cell: ({ row }) => <div>{row.original.views?.total_views || 0}</div>,
    },
  ];
};
